import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const redirectionTableFields: MapSearchInput['path'] = {
    name: ['id', 'label'],
    number: ['amount']
}
